import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const ChallengeQuestions = ({
	questions = [],
	onResponsesChange,
	required = true,
	clientQuestions,
	responsesOnly = false,
	disabled = false,
}) => {
	const [question1, setQuestion1] = useState(-1);
	const [question2, setQuestion2] = useState(-1);
	const [question3, setQuestion3] = useState(-1);
	const [answer1, setAnswer1] = useState('');
	const [answer2, setAnswer2] = useState('');
	const [answer3, setAnswer3] = useState('');
	useEffect(() => {
		const security_questions = [
			{ question_id: question1, answer: answer1 },
			{ question_id: question2, answer: answer2 },
			{ question_id: question3, answer: answer3 },
		];
		onResponsesChange(security_questions);
	}, [question1, question2, question3, answer1, answer2, answer3]);
	useEffect(() => {
		if (Array.isArray(clientQuestions) && clientQuestions.length === 3) {
			setQuestion1(clientQuestions[0].question_id);
			setQuestion2(clientQuestions[1].question_id);
			setQuestion3(clientQuestions[2].question_id);
		}
	}, [clientQuestions]);

	const questionSet1 = questions.filter(
		({ id }) => id != question2 && id != question3,
	);
	const questionSet2 = questions.filter(
		({ id }) => id != question1 && id != question3,
	);
	const questionSet3 = questions.filter(
		({ id }) => id != question1 && id != question2,
	);

	return (
		<>
			<div className="form-control">
				<label htmlFor="question1" className="label label-text">
					Question 1
				</label>
				{responsesOnly ? (
					<div className="px-4 py-2">
						{questions?.find(({ id }) => id === question1)?.question}
					</div>
				) : (
					<select
						id="question1"
						name="question1"
						required={required}
						className="select select-bordered"
						onChange={({ target }) => setQuestion1(target.value)}
						value={question1}
						disabled={disabled}
					>
						<option value={-1}>Choose...</option>
						{questionSet1.map(({ id, question }) => (
							<option key={`${id}`} value={id}>
								{question}
							</option>
						))}
					</select>
				)}
			</div>
			<div className="form-control">
				<label htmlFor="answer1" className="label label-text">
					Answer 1
				</label>
				<input
					id="answer1"
					name="answer1"
					type="text"
					required={required}
					className="input input-bordered"
					onChange={({ target }) => setAnswer1(target.value)}
					value={answer1}
					disabled={disabled}
				/>
			</div>
			<div className="form-control">
				<label htmlFor="question2" className="label label-text">
					Question 2
				</label>
				{responsesOnly ? (
					<div className="px-4 py-2">
						{questions?.find(({ id }) => id === question2)?.question}
					</div>
				) : (
					<select
						id="question2"
						name="question2"
						required={required}
						className="select select-bordered"
						onChange={({ target }) => setQuestion2(target.value)}
						value={question2}
						disabled={disabled}
					>
						<option value={-1}>Choose...</option>
						{questionSet2.map(({ id, question }) => (
							<option key={`${id}`} value={id}>
								{question}
							</option>
						))}
					</select>
				)}
			</div>
			<div className="form-control">
				<label htmlFor="answer2" className="label label-text">
					Answer 2
				</label>
				<input
					id="answer2"
					name="answer2"
					type="text"
					required={required}
					className="input input-bordered"
					onChange={({ target }) => setAnswer2(target.value)}
					value={answer2}
					disabled={disabled}
				/>
			</div>
			<div className="form-control">
				<label htmlFor="question3" className="label label-text">
					Question 3
				</label>
				{responsesOnly ? (
					<div className="px-4 py-2">
						{questions?.find(({ id }) => id === question3)?.question}
					</div>
				) : (
					<select
						id="question3"
						name="question3"
						required={required}
						className="select select-bordered"
						onChange={({ target }) => setQuestion3(target.value)}
						value={question3}
						disabled={disabled}
					>
						<option value={-1}>Choose...</option>
						{questionSet3.map(({ id, question }) => (
							<option key={`${id}`} value={id}>
								{question}
							</option>
						))}
					</select>
				)}
			</div>
			<div className="form-control">
				<label htmlFor="answer3" className="label label-text">
					Answer 3
				</label>
				<input
					id="answer3"
					name="answer3"
					type="text"
					required={required}
					className="input input-bordered"
					onChange={({ target }) => setAnswer3(target.value)}
					value={answer3}
					disabled={disabled}
				/>
			</div>
		</>
	);
};

ChallengeQuestions.propTypes = {
	questions: PropTypes.arrayOf(PropTypes.object),
	onResponsesChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	clientQuestions: PropTypes.array,
	responsesOnly: PropTypes.bool,
	disabled: PropTypes.bool,
};

export default ChallengeQuestions;
